import { IEmployeeAppContact } from '@dadohr/shared/domainTypes/experience';
import {
  PAEventType,
  ProductAnalyticsEvent
} from '@dadohr/shared/domainTypes/productAnalytics';
import { Button, Typography } from '@material-ui/core';
import { Mail } from 'lucide-react';
import { FlexContainerVertical } from '../../../../../../layout/Flex';

export const Contact = ({
  d,
  trackFn
}: {
  d: IEmployeeAppContact;
  trackFn?: (ev: ProductAnalyticsEvent) => void;
}) => {
  return (
    <FlexContainerVertical fullWidth spacing={0.5}>
      <FlexContainerVertical spacing={0}>
        <strong>{d.name}</strong>
        {d.description && (
          <Typography variant="caption">{d.description}</Typography>
        )}
      </FlexContainerVertical>
      <Button
        size="small"
        color="primary"
        variant="text"
        href={`mailto:${d.contacts.email}`}
        onClick={
          trackFn &&
          (() => {
            trackFn({
              eventType: PAEventType.EMPLOYEE_EXPERIENCE_INSTANCE,
              name: 'Contacts Link Clicked',
              Explanation: 'User clicked on a link in the Contacts section',
              'Contact Name': d.name,
              'Link Title': 'Email'
            });
          })
        }
        startIcon={<Mail size={14} />}
      >
        {d.contacts.email}
      </Button>
    </FlexContainerVertical>
  );
};
